export default "__VITE_ASSET__CaNtB9VU__"